export const CF_IMAGE_URLS = {
  'sukritwellness-logo-color':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/f26034af-ea1b-4da8-8e8e-9c7df30ff100/publicMedium',
  'certifications-ministry-ayush':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/70b44f09-ad9f-40ea-be88-f781a34c4400/public',
  'certifications-ficci':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/f333d855-7567-4cd8-e957-7bdd9bc77800/public',
  'certifications-icc-with-text':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/3307b8e9-4602-43f0-e87e-fddd5d8a9b00/public',
  'certifications-icc': 'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/f5885d98-09b7-4725-8fd9-ad8bd8a5fb00/public',
  'certifications-inbound-tour-operator':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/59c414fb-203a-4f51-cc97-6b127549c800/public',
  'certifications-incredible-india':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/8821daa2-06bf-4581-0984-ff5e4a492a00/public',
  'certifications-iatp': 'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/9930b5bd-b311-4897-0f81-7694fc4d6400/public',
  'certifications-ministry-tourism':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/31025c91-2058-4976-fee1-95435109cc00/public',
  'certifications-yoga-board':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/98c5ffce-0872-4c8c-b305-4e2807323800/public',
  'hero-cover': 'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/2392a72e-b36a-4d6a-20e4-7307c8756b00/public',
  'hero-cover-v2': 'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/965e05c7-148a-4de2-1ef7-b7af4974de00/public',
  'founder-gallery-1': 'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/c0ca1c79-5497-4792-cd58-145997b0ea00/public',
  'founder-gallery-2': 'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/24f4f757-32a1-4a7e-e448-f8ead3991500/public',
  'founder-gallery-3': 'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/b259fb43-ee3f-44e6-80e6-ba363b01bb00/public',
  'kumbh-sukrit-logo-black':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/b382adad-6469-4266-82c1-49c512387100/public',
  'kumbh-sukrit-brand-card':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/7b9b3a17-6163-42b4-3191-fc8363a66d00/public',
  'ks-testimonial-valarie-thumbnail':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/27bd91ea-7bdd-4aa8-ad05-ec9a0faa6b00/public',
  'camp67-logo-white': 'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/3fc3405b-8c7e-4030-6436-6646a245ea00/public',
  'camp-67-brand-card':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/3336b767-bd83-4a08-1007-59a778b7de00/publicMedium',
  'our-team-manak-profile':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/10128e06-cb48-4c73-871e-a5d18e17a000/public',
  'our-team-abhimanu-profile':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/7d06e568-748f-491a-3d15-f63766753200/public',
  'hero-video-poster': 'https://imagedelivery.net/6af3d701-c184-4125-4fc2-b7c0d7342200/public',
  // Home page image grid
  'photo-with-sadhu':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/519aedb4-e815-45b8-cfad-899da341f900/publicMedium',
  'smd-colorful': 'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/0421164c-9699-47d0-5467-ec5cbe532b00/publicMedium',
  'drone-overview-of-camp':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/45012575-c885-4e6f-0f87-4ce2b8e4fd00/publicMedium',
  'mud-house-food':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/30f2a0d6-3c3a-4f42-cd6f-dea774d18400/publicMedium',
  'group-havan': 'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/d8fe5102-0a0b-4d81-70de-0dbb7f717400/publicMedium',
  'group-gaushala':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/24f6c7e5-c20c-47fb-7787-65fcd47f7e00/publicMedium',
  'mud-house-food-tent':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/a6658141-538d-4991-5796-605aff48f600/publicMedium',
  'premium-tent-grounds':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/f9f895f4-52d5-4c3f-10a8-5631c04bb900/publicMedium',
  'gaushala-single-shot':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/c53ea9f7-ff51-4fe6-2b47-ff1af8204800/publicMedium',
  'smd-2025': 'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/c3068c91-175a-4c12-001e-0d61642cbb00/publicMedium',
  // Testimonial switcher images
  'francesca-kumbh-2025':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/8a4a71c2-55bf-42ac-3916-f07085b55a00/publicMedium',
  'valerie-kumbh-2025':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/268e822c-614f-4e37-4fe1-a71a1b30fc00/publicMedium',
  'naamdeo-testimonial-poster':
    'https://imagedelivery.net/Knvys86jJSy4RAoUACMsVg/0228643d-1303-4f41-20b2-cde36fa3bd00/publicMedium',
};
